export default {
  apiKey: 'AIzaSyCzCGupaopIiTo-xDirrZgszT7edav83-A',
  authDomain: 'liturgy-56f31.firebaseapp.com',
  databaseURL: 'https://liturgy-56f31.firebaseio.com',
  projectId: 'liturgy-56f31',
  storageBucket: 'liturgy-56f31.appspot.com',
  messagingSenderId: '10749412771'
}



// WEBPACK FOOTER //
// ./src/firebase/FirebaseConfig.js